import { __read } from "tslib";
import cn from 'classnames';
import * as React from 'react';
import { memo, useCallback, useRef, useState } from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import { useTranslation } from 'react-i18next';
import { addPassenger, removePassenger } from '../../../store/passengers/actions';
import { getPassengers, getPassengersTitle, getTotalPassengersCount } from '../../../store/passengers/selectors';
import { isMultiCity } from '../../../store/segments/selectors';
import Dropdown from '../../../../Dropdown';
import { MOBILE_MIN_WIDTH } from '../../../../utils';
import { SlideBottom } from '../../../../SlideBottom/components/SlideBottom';
import { Passengers as PassengersComponent } from '../../../../Passengers/components/Passengers';
import { useConfig } from '../../../../context';
import { useTheme } from '../../../../theme';
import { Tooltip } from '../../../../index';
var arrowIcon = (React.createElement("svg", { width: "10", height: "5", viewBox: "0 0 10 5", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M0 0L5 5L10 0L0 0Z", fill: "currentColor" })));
var passengerIcon = (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", { opacity: "0.5" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 12C13.66 12 15 10.66 15 9C15 7.34 13.66 6 12 6C10.34 6 9 7.34 9 9C9 10.66 10.34 12 12 12ZM12 13.9C10 13.9 6 15 6 17V18H18V17C18 15 14 13.9 12 13.9Z", fill: "white" }))));
var Passengers = memo(function (_a) {
    var _b, _c, _d;
    var isMultiCity = _a.isMultiCity, passengersTitle = _a.passengersTitle, passengers = _a.passengers, addPassenger = _a.addPassenger, removePassenger = _a.removePassenger, passengersCount = _a.passengersCount;
    var css = useTheme('SearchForm').Passengers;
    var alternative = useConfig().SearchForm.mobileFormType !== 'common';
    var _e = __read(useState(false), 2), isOpen = _e[0], setIsOpen = _e[1];
    var t = useTranslation('SearchForm').t;
    var buttonRef = useRef();
    var open = useCallback(function () { return setIsOpen(!isOpen); }, [isOpen]);
    var close = useCallback(function () { return setIsOpen(false); }, []);
    var focus = useCallback(function (event) { return event.target.blur(); }, []);
    var onClose = useCallback(function (event) {
        if (event.target !== buttonRef.current) {
            close();
        }
    }, [buttonRef]);
    return (React.createElement("div", { className: cn(css.passengers, (_b = {},
            _b[css.passengers_isMultiCity] = isMultiCity,
            _b[css.alternative] = alternative,
            _b)) },
        React.createElement(Tooltip, { title: t('Please select passengers'), open: passengersCount === 0, interactive: false },
            React.createElement("button", { type: "button", ref: buttonRef, className: cn(css.selector, (_c = {}, _c[css.selector_focused] = isOpen, _c)), onClick: open, onFocus: focus },
                React.createElement(MediaQuery, { maxWidth: MOBILE_MIN_WIDTH },
                    React.createElement("span", { className: css.passengerIcon }, passengerIcon)),
                React.createElement("span", { className: css.title }, passengersTitle),
                React.createElement("span", { className: cn(css.arrowIcon, (_d = {}, _d[css.arrowIcon_flipped] = isOpen, _d)) }, arrowIcon))),
        React.createElement(MediaQuery, { minWidth: MOBILE_MIN_WIDTH },
            React.createElement(Dropdown, { isOpen: isOpen, onClose: onClose },
                React.createElement("div", { className: css.menu },
                    React.createElement(PassengersComponent, { passengers: passengers, removePassenger: removePassenger, addPassenger: addPassenger })))),
        React.createElement(MediaQuery, { maxWidth: MOBILE_MIN_WIDTH },
            React.createElement(SlideBottom, { isOpen: isOpen, onClose: close },
                React.createElement("div", { className: css.mobileMenu },
                    React.createElement("h3", { className: css.mobileTitle }, t('Passengers')),
                    React.createElement(PassengersComponent, { passengers: passengers, removePassenger: removePassenger, addPassenger: addPassenger }))))));
});
var mapStateToProps = function (state) {
    return {
        isMultiCity: isMultiCity(state),
        passengersTitle: getPassengersTitle(state),
        passengers: getPassengers(state),
        passengersCount: getTotalPassengersCount(state)
    };
};
var mapDispatchToProps = {
    addPassenger: addPassenger,
    removePassenger: removePassenger
};
export default connect(mapStateToProps, mapDispatchToProps)(Passengers);
